/**
 * Centralized configuration for `react-hot-toast`.
 * Import and use in `layout.tsx` as `<Toaster {...toasterConfig} />`.
 */
export const toasterConfig = {
  position: "top-center" as const,
  gutter: 8,
  containerStyle: {
    top: 24,
    bottom: 24,
    left: 24,
    right: 24
  },
  toastOptions: {
    // Default options for standard toasts (if any slip through)
    duration: 4000,
    style: {
      background: "#333",
      color: "#fff"
    },
    // Remove default styles as we are using custom components
    className: ""
  }
};

export default toasterConfig;
